import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectionItem } from '@shared/components/selection/selection-item';

@Component({
  selector: 'app-selection-modal',
  templateUrl: './selection-modal.component.html',
  styleUrls: ['./selection-modal.component.scss']
})
export class SelectionModalComponent implements OnInit {

  @Input()
  title: string = '';

  @Input()
  selectionItems: SelectionItem[] = [];

  // Input callback for when component is used with ngx-bootstrap modal service (planner)
  @Input()
  onCloseCallback?: () => void;

  private readonly _closeEmitter = new EventEmitter<void>();

  @Output() 
  close = this._closeEmitter;

  constructor() { }

  ngOnInit(): void {
  }

  onClose() {
    // If callback is provided, call it (planner/ngx-bootstrap modal service usage)
    if (this.onCloseCallback) {
      this.onCloseCallback();
    } else {
      // Emit the event for template-based usage (list view)
      this._closeEmitter.emit();
    }
  }
}
